import { Typography, Grid } from "@material-ui/core"
import React, { memo } from "react"
import { CenterContainer, LeftContainer, RightContainer, StyledAppBar, StyledGridItem } from "./style"

type TProps = {
  leftComponent?: JSX.Element
  centerComponent?: JSX.Element
  rightComponent?: JSX.Element
}

function AppBar({ leftComponent, centerComponent, rightComponent }: TProps) {
  return (
    <StyledAppBar color="primary" position="sticky" elevation={0}>
      <Grid container={true}>
        <StyledGridItem item={true}>
          <LeftContainer>{leftComponent}</LeftContainer>
        </StyledGridItem>
        {centerComponent && (
          <StyledGridItem item={true}>
            <CenterContainer>
              <Typography variant="h4">{centerComponent}</Typography>
            </CenterContainer>
          </StyledGridItem>
        )}
        <StyledGridItem item={true}>
          <RightContainer>{rightComponent}</RightContainer>
        </StyledGridItem>
      </Grid>
    </StyledAppBar>
  )
}

export default memo(AppBar)
